import styled from 'styled-components';

export const DateRangeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: ${({ theme }): string => theme.spacers!.spacer01};
  z-index: 16;

  .custom-date-range-picker {
    min-width: 216px;
    border-radius: 4px;
    border: 1px solid ${({ theme }): string => theme.admanColors!.gray.light.bg0[5]};

    :hover:not(:focus) {
      border: 1px solid ${({ theme }): string => theme.admanColors!.gray.light.bg0[5]};
      box-shadow: inset 0 0 1px 1px ${({ theme }): string => theme.admanColors!.gray.light.bg0[5]};
    }

    :focus {
      outline: none;
      box-shadow: inset 0 0 1px 1px ${({ theme }): string => theme.admanColors!.gray.light.fg[0]};
      border: 1px solid ${({ theme }): string => theme.admanColors!.gray.light.fg[0]};
    }
  }
`;
